"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderEvent = void 0;
var canvas_1 = require("../../canvas");
var color_1 = __importDefault(require("color"));
var renderEvent = function (ctx, _a) {
    var y = _a.y, x = _a.x, w = _a.w, h = _a.h, fillStyle = _a.fillStyle, strokeStyle = _a.strokeStyle, selectedColor = _a.selectedColor, hover = _a.hover, selected = _a.selected, dragging = _a.dragging, scale = _a.scale, name = _a.name, labelSize = _a.labelSize, radius = _a.radius, _b = _a.showHandles, showHandles = _b === void 0 ? false : _b;
    var handleWidth = Math.min(w / 4, 8);
    var handleColor = (0, color_1.default)(fillStyle).darken(0.1).toString();
    var mouseOver = hover.x > x && hover.x < x + w && hover.y > y && hover.y < y + h;
    radius = radius / 6;
    if (mouseOver) {
        (0, canvas_1.roundedRect)(ctx, {
            x: x,
            y: y,
            radius: radius,
            lineWidth: 8,
            strokeStyle: "rgba(0,0,0,0.1)",
            h: h,
            w: w,
            scale: scale,
        });
    }
    (0, canvas_1.roundedRect)(ctx, {
        x: x,
        y: y,
        fillStyle: fillStyle,
        radius: radius,
        lineWidth: 1,
        strokeStyle: strokeStyle,
        h: h,
        w: w,
        scale: scale,
    });
    if (showHandles) {
        (0, canvas_1.roundedRect)(ctx, {
            x: x + 1,
            y: y + 1,
            fillStyle: handleColor,
            radius: radius,
            h: h - 2,
            w: handleWidth,
            scale: scale,
        });
        (0, canvas_1.roundedRect)(ctx, {
            x: x + w - handleWidth - 1,
            y: y + 1,
            fillStyle: handleColor,
            radius: radius,
            h: h - 2,
            w: handleWidth,
            scale: scale,
        });
    }
    // Render selection indicator
    if (dragging) {
        (0, canvas_1.roundedRect)(ctx, {
            x: x - 1,
            y: y - 1,
            radius: radius,
            lineWidth: 3,
            strokeStyle: selectedColor,
            h: h + 2,
            w: w + 2,
            scale: scale,
        });
    }
    else if (selected) {
        (0, canvas_1.roundedRect)(ctx, {
            x: x - 1,
            y: y - 1,
            radius: radius,
            lineWidth: 3,
            strokeStyle: selectedColor,
            lineDash: [7, 7],
            h: h + 2,
            w: w + 2,
            scale: scale,
        });
    }
    (0, canvas_1.label)(ctx, {
        x: x + w + 4,
        y: y + h / 2,
        text: name,
        labelSize: labelSize,
        baseline: "middle",
        scale: scale,
    });
    return { mouseOver: mouseOver };
};
exports.renderEvent = renderEvent;
